const confirmDeletingCustomGroup = 'confirmDeletingCustomGroup';
const confirmDiscardCustomGroupChanges = 'confirmDiscardCustomGroupChanges';

export default {
  confirmDeletingCustomGroup,
  confirmDiscardCustomGroupChanges,
};
